<template lang="pug">
  .PostContentTags.post-content-tags
    router-link.post-content-tags__tag(
      v-for="tag in data.tags",
      :key="tag.slug",
      :to="tag.route"
      :aria-label="`Click on ${tag.name} tag`"
    )
      span.post-content-tags__tag-hash #
      |  {{ tag.name }}
</template>

<script>
import { BasePostClass } from 'Classes';

export default {
  name: 'PostContentTags',
  props: {
    data: {
      type: BasePostClass,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.post-content-tags
  display: flex
  flex-direction: row
  flex-wrap: wrap
  &__tag
    display: flex
    background: $alabaster
    border-radius: 2px
    padding: 6px 10px
    font-size: 12px
    line-height: 19px !important
    color: $primary !important
    +font(500, !important)
    border-bottom: none !important
    margin-right: 10px
    margin-bottom: 10px
    @media screen and (max-width: 767px)
      margin: 5px
  &__tag-hash
    +font(800)
    color: rgba($text_gray, 0.3)
    margin-right: 3px
</style>
